import EnrollmentLink from '@/enroll/entities/link-generator/enrollment-link.entity';
import omitBy from 'lodash/omitBy';

export default class EnrollmentLinkService {
  public static composeEnrollmentUrl(enrollmentLink: EnrollmentLink): string {
    const basePath = process.env.VUE_APP_ENROLLMENT_LINK_PREFIX;

    const queryParams = this.extractQueryParams(enrollmentLink);
    const formattedQueryParams = this.formatQueryParams(queryParams);
    return `${basePath}?${formattedQueryParams}`;
  }

  private static extractQueryParams(enrollmentLink: EnrollmentLink): any {
    return omitBy({
      sponsor: enrollmentLink.sponsorId,
      country: enrollmentLink.country,
      language: enrollmentLink.language,
      firstName: enrollmentLink.firstName,
      lastName: enrollmentLink.lastName,
      phone: enrollmentLink.phone,
      email: enrollmentLink.email,
      placement: enrollmentLink.placement,
    }, (value) => !value);
  }

  private static formatQueryParams(queryParams: any): string {
    const cleanParams = Object.keys(queryParams)
      .filter((key: string) => queryParams[key] != null)
      .map((key: string) => `${key}=${queryParams[key]}`);

    return cleanParams.join('&');
  }
}
